// tslint:disable:no-console
import store from '@/store';
import Vue from 'Vue';

export enum LogSeverity {
    debug,
    info,
    warning,
    error,
    fatal,
}

export interface ILogEntry {
    tag: string;
    severity: LogSeverity;
    message: string;
    timestamp: Date;
}


export class Logger {
    public static log(logEntry: ILogEntry) {
        store.commit('logging/log', logEntry);
        if (console && console.log && console.info && console.debug && console.warn && console.error) {
            switch (logEntry.severity) {
                case LogSeverity.info:
                    console.info(`${logEntry.tag} | ${logEntry.message}`);
                    break;
                case LogSeverity.debug:
                    console.debug(`${logEntry.tag} | ${logEntry.message}`);
                    break;
                case LogSeverity.warning:
                    console.warn(`${logEntry.tag} | ${logEntry.message}`);
                    break;
                case LogSeverity.error:
                case LogSeverity.fatal:
                    console.error(`${logEntry.tag} | ${logEntry.message}`);
                    break;
                default:
                    console.log(`${logEntry.tag} | ${logEntry.message}`);
                    break;
            }
        }
    }

    public logTag: string;

    constructor(logTag: string) {
        this.logTag = logTag;
    }

    public debug(message: any, ...args: any) {
        Logger.log({
            tag: this.logTag,
            severity: LogSeverity.debug,
            message: this.formatArguments(message, args),
            timestamp: new Date(),
        });
    }
    public info(message: any, ...args: any) {
        Logger.log({
            tag: this.logTag,
            severity: LogSeverity.info,
            message: this.formatArguments(message, args),
            timestamp: new Date(),
        });
    }
    public warn(message: any, ...args: any) {
        Logger.log({
            tag: this.logTag,
            severity: LogSeverity.warning,
            message: this.formatArguments(message, args),
            timestamp: new Date(),
        });
    }
    public error(message: any, ...args: any) {
        Logger.log({
            tag: this.logTag,
            severity: LogSeverity.error,
            message: this.formatArguments(message, args),
            timestamp: new Date(),
        });
    }
    public fatal(message: any, ...args: any) {
        Logger.log({
            tag: this.logTag,
            severity: LogSeverity.fatal,
            message: this.formatArguments(message, args),
            timestamp: new Date(),
        });
    }


    private formatArguments(message: any, ...args: any): string {
        // const formattedArguments = true ? args.map((a: any) => JSON.stringify(a)) : args;
        return message;
    }
}


export default function getLogger(logTag: string) {
    return new Logger(logTag);
}
